

export class TourTripDataOutput implements ITourTripDataOutput {
    /** The auto-generated id of the tour_trip_timing */
    tour_trip_timing_id!: number;
    /** The auto-generated id of the tour_coordinate_path */
    tour_coordinate_point_id!: number;
    /** The arrival time should be 20 character */
    arrival_time!: string;
    /** The arrival halt time should be 20 character */
    arrival_halt_time!: string;

    constructor(data?: ITourTripDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_trip_timing_id = _data["tour_trip_timing_id"];
            this.tour_coordinate_point_id = _data["tour_coordinate_point_id"];
            this.arrival_time = _data["arrival_time"];
            this.arrival_halt_time = _data["arrival_halt_time"];
        }
    }

    static fromJS(data: any): TourTripDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TourTripDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_trip_timing_id"] = this.tour_trip_timing_id;
        data["tour_coordinate_point_id"] = this.tour_coordinate_point_id;
        data["arrival_time"] = this.arrival_time;
        data["arrival_halt_time"] = this.arrival_halt_time;
        return data; 
    }
}

export interface ITourTripDataOutput {
    /** The auto-generated id of the tour_trip_timing */
    tour_trip_timing_id: number;
    /** The auto-generated id of the tour_coordinate_path */
    tour_coordinate_point_id: number;
    /** The arrival time should be 20 character */
    arrival_time: string;
    /** The arrival halt time should be 20 character */
    arrival_halt_time: string;
}

